<template>
  <div>
    <HeaderComponent/>
    <Privacy/>
    <FooterComponent/>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderPayment';
import Privacy from '@/components/Privacy';
import FooterComponent from '@/components/Footer.vue';
export default {
  name: "PrivacyPolicy",
  components: {
    HeaderComponent,
    Privacy,
    FooterComponent,
  }
}
</script>

<style scoped>
</style>